import { render, staticRenderFns } from "./app-video.vue?vue&type=template&id=64cc8028&"
import script from "./app-video.vue?vue&type=script&lang=js&"
export * from "./app-video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports